<<template>
  <div style="display: flex;gap:8px">
    <el-card shadow="never" class="left-list">
      <my-folder ref="folderTree" />
    </el-card>
    <el-card shadow="never" style="flex: 1;" :key="getVal">
      <advancedSearch @reloadFolder='reloadFolder' />
    </el-card>
  </div>
</template>

<script>
import advancedSearch from './forFolder.vue';
import MyFolder from "@/views/components/myfolder.vue";
export default {
  components: { advancedSearch, MyFolder },
  computed: {
    getSaveSearch() {
      // return this.$store.state.setSaveSearch;
    },
    getVal() {
      const { seekId } = this.$route.query;
      return seekId
    }
  },
  methods: {
    reloadFolder() {
      this.$refs.folderTree.getData();
    }
  },
}
</script>

<style scoped>
.left-list {
  width: 360px;
  flex-shrink: 0;
  height: calc(100vh - 150px);
  overflow: auto;
  padding-bottom: 10px;
  }

</style>